import { render, staticRenderFns } from "./BC_articleInfo.vue?vue&type=template&id=5529a9a8&scoped=true&"
import script from "./BC_articleInfo.vue?vue&type=script&lang=js&"
export * from "./BC_articleInfo.vue?vue&type=script&lang=js&"
import style0 from "./BC_articleInfo.vue?vue&type=style&index=0&id=5529a9a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5529a9a8",
  null
  
)

export default component.exports